import { render, staticRenderFns } from "./ZhoekWebPage.vue?vue&type=template&id=067a3690&"
import script from "./ZhoekWebPage.vue?vue&type=script&lang=js&"
export * from "./ZhoekWebPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports